(function () {
  "use strict";
  if (window.__boveaSaleCountdownV2Installed) return;
  window.__boveaSaleCountdownV2Installed = true;

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, "0");
  }

  function update(widget) {
    var raw = widget.getAttribute("data-sale-end");
    var target = raw ? new Date(raw).getTime() : 0;
    var output = widget.querySelector("[data-sale-countdown]");
    if (!output || !target) return;

    var diff = Math.max(target - Date.now(), 0);
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    output.textContent = pad(days) + "T " + pad(hours) + ":" + pad(minutes) + ":" + pad(seconds);
  }

  function updateAll() {
    document.querySelectorAll("[data-bovea-sale-progress]").forEach(update);
  }

  document.addEventListener("DOMContentLoaded", updateAll);
  document.addEventListener("shopify:section:load", updateAll);
  updateAll();
  window.setInterval(updateAll, 1000);
})();

/* BOVEA Preview · gemeinsame Feedback-Sterne + große Homepage Quick Adds */
(function () {
  "use strict";

  if (window.__boveaPreviewHomepageTune2908Installed) return;
  window.__boveaPreviewHomepageTune2908Installed = true;

  var STYLE_ID = "bovea-preview-homepage-tune-2908";
  var resizeTimer = null;

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
/* Kundenfeedback Sterne auf Start- und Produktseite bewusst identisch */
[id^="LuminoHomepage"] .lh-review-stars,
[id^="LuminoProductNord_"] .lp-home-review-stars {
  color: #D4A33F !important;
  font-size: 12px !important;
  line-height: 1 !important;
  font-weight: 700 !important;
  letter-spacing: .7px !important;
  text-shadow: none !important;
  -webkit-text-stroke: 0 !important;
}

[id^="LuminoHomepage"] .lh-review-stars {
  margin-bottom: 8px !important;
  padding: 4px 8px !important;
  border-color: rgba(212, 163, 63, .38) !important;
  background: rgba(18, 14, 11, .10) !important;
}

[id^="LuminoHomepage"] .lh-review-meta,
[id^="LuminoHomepage"] .lh-review-title,
[id^="LuminoHomepage"] .lh-review-text {
  color: #FFFFFF !important;
}

/* Startseite: Quick Add sichtbar größer und weiterhin auf Titelhöhe */
[id^="LuminoHomepage"] .lh-statement-card {
  position: relative !important;
}
[id^="LuminoHomepage"] .lh-statement-info {
  padding-right: 60px !important;
}
[id^="LuminoHomepage"] .bovea-home-quick-add {
  position: absolute !important;
  z-index: 20 !important;
  right: 2px !important;
  top: var(--bovea-quick-add-top, 0px) !important;
  width: 50px !important;
  height: 50px !important;
  min-width: 50px !important;
  min-height: 50px !important;
  padding: 0 !important;
  border: 1px solid rgba(47, 41, 36, .14) !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, .98) !important;
  color: #2F2924 !important;
  box-shadow: 0 7px 20px rgba(47, 41, 36, .13) !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  transition: transform .18s ease, box-shadow .18s ease, background .18s ease !important;
}
[id^="LuminoHomepage"] .bovea-home-quick-add:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 10px 24px rgba(47, 41, 36, .16) !important;
}
[id^="LuminoHomepage"] .bovea-home-quick-add:focus-visible {
  outline: 2px solid #2F2924 !important;
  outline-offset: 2px !important;
}
[id^="LuminoHomepage"] .bovea-home-quick-add svg {
  width: 22px !important;
  height: 22px !important;
  display: block !important;
}
[id^="LuminoHomepage"] .bovea-home-quick-add.is-loading {
  opacity: .55 !important;
  pointer-events: none !important;
}
[id^="LuminoHomepage"] .bovea-home-quick-add.is-added {
  background: #F4F1EA !important;
}

@media screen and (max-width: 749px) {
  [id^="LuminoHomepage"] .lh-review-card {
    flex: 0 0 76vw !important;
    width: 76vw !important;
    min-width: 248px !important;
    max-width: 292px !important;
    height: 350px !important;
    min-height: 350px !important;
    aspect-ratio: auto !important;
    border-radius: 18px !important;
  }
  [id^="LuminoHomepage"] .lh-review-content {
    padding: 16px !important;
  }
  [id^="LuminoHomepage"] .lh-review-stars,
  [id^="LuminoProductNord_"] .lp-home-review-stars {
    font-size: 11.5px !important;
    letter-spacing: .6px !important;
  }

  [id^="LuminoHomepage"] .lh-statement-info {
    padding-right: 58px !important;
  }
  [id^="LuminoHomepage"] .bovea-home-quick-add {
    right: 1px !important;
    width: 48px !important;
    height: 48px !important;
    min-width: 48px !important;
    min-height: 48px !important;
  }
  [id^="LuminoHomepage"] .bovea-home-quick-add svg {
    width: 21px !important;
    height: 21px !important;
  }
}
`;
    document.head.appendChild(style);
  }

  function cartIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3.5 5.5h2.2l1.8 9.1h9.9l2.1-6.2H7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.3" cy="18.4" r="1.25" fill="currentColor"/><circle cx="17.1" cy="18.4" r="1.25" fill="currentColor"/></svg>';
  }

  function checkIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.3 4.2L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function errorIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 7.5v6M12 17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/></svg>';
  }

  function productData(card) {
    if (card._boveaHomeProductPromise) return card._boveaHomeProductPromise;
    var link = card.querySelector('.lh-statement-link[href]');
    if (!link) return Promise.reject(new Error('link'));

    var url = new URL(link.getAttribute('href'), window.location.origin);
    var path = url.pathname.replace(/\/$/, '');
    card._boveaHomeProductPromise = fetch(path + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('product');
      return response.json();
    });

    return card._boveaHomeProductPromise;
  }

  function addVariant(variantId) {
    var id = Number(variantId || 0);
    if (!id) return Promise.reject(new Error('variant'));

    if (window.BoveaCart && typeof window.BoveaCart.add === 'function') {
      return window.BoveaCart.add({ id: id, quantity: 1, properties: {} });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('add');
      return response.json();
    });
  }

  function refreshCartCounts() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.lh-cart-count, .lc-cart-count, .cart-count-bubble').forEach(function (count) {
          count.textContent = cart.item_count;
        });
        return cart;
      });
  }

  function positionQuickAdd(card, button) {
    var media = card.querySelector('.lh-statement-media');
    if (!media || !button) return;
    card.style.setProperty('--bovea-quick-add-top', (media.offsetHeight + 8) + 'px');
  }

  function installHomepageQuickAdd() {
    var cards = document.querySelectorAll('[id^="LuminoHomepage"] .lh-statement-card');

    cards.forEach(function (card) {
      var button = card.querySelector('.bovea-home-quick-add');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'bovea-home-quick-add';
        button.setAttribute('aria-label', 'Schnell zum Warenkorb hinzufügen');
        button.setAttribute('title', 'Schnell hinzufügen');
        button.innerHTML = cartIcon();
        card.appendChild(button);

        ['pointerdown', 'mousedown', 'touchstart'].forEach(function (eventName) {
          button.addEventListener(eventName, function (event) {
            event.stopPropagation();
          }, { passive: true });
        });

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (button.classList.contains('is-loading')) return;

          button.classList.add('is-loading');
          productData(card)
            .then(function (product) {
              var variants = Array.isArray(product.variants) ? product.variants : [];
              var variant = variants.find(function (candidate) { return candidate.available; }) || variants[0];
              if (!variant) throw new Error('variant');
              return addVariant(variant.id);
            })
            .then(function () {
              return refreshCartCounts().catch(function () {});
            })
            .then(function () {
              button.classList.remove('is-loading');
              button.classList.add('is-added');
              button.innerHTML = checkIcon();
              window.setTimeout(function () {
                button.classList.remove('is-added');
                button.innerHTML = cartIcon();
              }, 1300);
            })
            .catch(function () {
              button.classList.remove('is-loading');
              button.innerHTML = errorIcon();
              window.setTimeout(function () {
                button.innerHTML = cartIcon();
              }, 1400);
            });
        });
      }

      positionQuickAdd(card, button);
    });
  }

  function refreshPositions() {
    document.querySelectorAll('[id^="LuminoHomepage"] .lh-statement-card').forEach(function (card) {
      positionQuickAdd(card, card.querySelector('.bovea-home-quick-add'));
    });
  }

  function run() {
    installStyles();
    installHomepageQuickAdd();
    refreshPositions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(run, 40);
  });

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refreshPositions, 90);
  }, { passive: true });

  [250, 800, 1800].forEach(function (delay) {
    window.setTimeout(run, delay);
  });
})();
